import { trackError } from '@billy/track-error'
import { useCallback, useEffect, useRef } from 'react'

import { FecImportProcessingStatus } from '../enums/fecImportProcessingStatus'
import type { FecImportItem } from '../query-api'
import { isFecImportAnalysisFailed } from '../utils/isFecImportAnalysisFailed'

export const useFecImportAnalysisTracking = (fecImports: FecImportItem[]) => {
  const reportedAnalysisErrorIdsRef = useRef<Set<string>>(new Set())
  const reportedMissingPeriodIdsRef = useRef<Set<string>>(new Set())

  useEffect(() => {
    for (const fecImport of fecImports) {
      if (!isFecImportAnalysisFailed(fecImport) || reportedAnalysisErrorIdsRef.current.has(fecImport.id)) {
        continue
      }

      reportedAnalysisErrorIdsRef.current.add(fecImport.id)
      trackError(new Error(`FEC import analysis failed: ${fecImport.id}`))
    }
  }, [fecImports])

  useEffect(() => {
    for (const fecImport of fecImports) {
      const hasPeriod = fecImport.periodStart && fecImport.periodEnd

      if (
        fecImport.processingStatus !== FecImportProcessingStatus.Parsed ||
        hasPeriod ||
        reportedMissingPeriodIdsRef.current.has(fecImport.id)
      ) {
        continue
      }

      reportedMissingPeriodIdsRef.current.add(fecImport.id)
      trackError(new Error(`FEC import completed without period: ${fecImport.id}`))
    }
  }, [fecImports])

  return {
    resetReportedAnalysisErrors: useCallback(() => {
      reportedAnalysisErrorIdsRef.current.clear()
    }, []),
  }
}
